document.addEventListener('DOMContentLoaded', function () {
  try {
    var selector = '.site-nav .site-nav--has-dropdown > a .site-nav--link-wrapper';
    document.querySelectorAll(selector).forEach(function (wrapper) {
      if (!wrapper.querySelector('.nav-chevron-down')) {
        var span = document.createElement('span');
        span.className = 'site-nav--link-icon nav-chevron-down';
        span.setAttribute('aria-hidden', 'true');
        span.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' width='9' height='6' viewBox='0 0 9 6' fill='none'><path d='M1 1L4.5 4.5L8 1' stroke='currentColor' stroke-width='1.3' stroke-linecap='round'/></svg>";
        // Ensure the chevron respects link color
        span.style.color = 'inherit';
        wrapper.classList.add('inline-icon--wrapper', 'icon--right');
        wrapper.appendChild(span);
      }
    });
  } catch (e) {
    // no-op
  }
});


